// extracted by mini-css-extract-plugin
export default {"instructionsContainer":"GameInstructions_instructionsContainer__1o9Tq","gradient":"GameInstructions_gradient__EmZ-Q"};